import { qx_Sensor } from '@/graphql/types';
import { Ref, computed } from 'vue';

export const useSensorStatus = (sensorComputed: Ref<qx_Sensor>) => {
  //
  const enabled = computed(() => sensorComputed?.value?.enabled);

  // eDIOState
  const state = computed(() => sensorComputed?.value?.state);

  // eSensorType
  const alarm = computed(() => sensorComputed?.value?.type);

  //
  const disabledByLicense = computed(() => sensorComputed?.value?.disabledByLicense);

  // eBatteryLevel
  const battery = computed(() => sensorComputed?.value?.batteryLevel);

  //
  const gateway = computed(() => ({
    // connectionStatus: sensorComputed?.value?.device?.gateway?.connectionStatus,
    // syncStatus: sensorComputed?.value?.device?.gateway?.syncStatus,
    connectionStatus: sensorComputed.value?.gatewayConnectionStatus || sensorComputed?.value?.device?.gateway?.connectionStatus,
    // DEV NOTE :: syncStatus does not exist as a queryable field
    syncStatus: sensorComputed.value?.gatewaySyncStatus || sensorComputed?.value?.device?.gateway?.syncStatus
  }));

  // eDeviceConnectionStatus
  const connection = computed(() => {
    if (sensorComputed.value?.device?.enabled === false) {
      // use === false so I don't say device is disabled if I don't have device privilege
      return 'Disabled';
    }

    return sensorComputed.value?.deviceConnectionStatus || sensorComputed.value?.device?.connectionStatus;
  });

  return {
    enabled,
    state,
    alarm,
    disabledByLicense,
    gateway,
    connection,
    battery,
  };
};
